import React from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import { SpheraSpinner } from "@sphera-cloud/component-ui-reactjs";

export function DeleteModal(props) {
    const loadingPanel = (
        <div className="k-loading-mask">
            <span className="k-loading-text">{props.localizations.Loading}</span>
            <SpheraSpinner version={1} color="dark-1" />
        </div>
    );

    return (
        <div>
            {props.showDeleteModal && (
                <SpheraModal className="DeleteFilterModal" title={props.localizations.Delete} width={400} height={300}
                    onClose={props.toggleDeleteModal}
                    onCancel={props.toggleDeleteModal}
                    cancelText={props.localizations.Cancel}
                    actionText={props.localizations.Delete}
                    onAction={props.submitDelete}
                >
                    <div className="DeleteFilterModalDiv" >
                        <div>{props.DeleteConfirm}</div>
                        {props.modalPending && loadingPanel}
                    </div>
                </SpheraModal>
            )}
        </div>
    );
}